export default {
  loginTokens: 'login-tokens',
};
